import {AbstractControl, ValidatorFn} from '@angular/forms';

export const requiredTrimValidator = (): ValidatorFn => {
    return (control: AbstractControl): {[key: string]: any} | null => {
        return !!(control.value || '').trim() ? null : {requiredTrim: true};
    };
};
